import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQuery } from './baseQuery';
import type { StatisticsResponse } from '../pages/statistics/statistics.types';

export interface StatisticsParams {
    gridId: string;
    stationId: string;
    startDate: string;
    endDate: string;
}

export const transactionApi = createApi({
    reducerPath: 'transactionApi',
    baseQuery,
    endpoints: (builder) => ({
        getChargingStatistics: builder.query<StatisticsResponse, StatisticsParams>({
            query: ({ gridId, stationId, startDate, endDate }) => ({
                url: 'transaction-service/statistics/charging-statistics',
                params: {
                    gridId,
                    stationId,
                    startDate: new Date(startDate).toISOString().slice(0, 16),
                    endDate: new Date(endDate).toISOString().slice(0, 16),
                },
            }),
        }),
    }),
});

export const { useLazyGetChargingStatisticsQuery } = transactionApi;
